<p>setup-wizard-finished works!</p>
